import { latestBrandReleases } from '../../../shared/brand-latest/latestReleases';

export const books2026 = [
  ...latestBrandReleases
    .filter((book) => book.brandSlug === 'muye-culture')
    .map((book) => ({
      id: book.id,
      title: book.title,
      author: book.author,
      isbn: book.isbn,
      publishDate: book.publishDate,
      seriesCode: '',
      coverUrl: book.coverImage,
      description: book.summary,
      searchUrl: `https://search.books.com.tw/search/query?key=${book.isbn}`,
    })),
  {
    id: 'book-k6013',
    title: '色境——畫作中的名家',
    author: '諳小語',
    isbn: '9786267866207',
    seriesCode: 'K6013',
    coverUrl:
      'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/7623e9c0-cbab-456c-b44a-9ed79235fc7b_compressed_9786267866207_3D_72dpi.webp',
    description: '一件文物，一段人生；一座博物館，一部文明史。走進博物館，看見的不只是文物，還有千年文化的靈魂。',
    searchUrl: 'https://search.books.com.tw/search/query?key=9786267866207',
  },
  {
    id: 'book-k6011',
    title: '八卦三國——東漢末年的舊案與新聞',
    author: '高山淳',
    isbn: '9786267866184',
    seriesCode: 'K6011',
    coverUrl:
      'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/99dfa6c8-6a3a-4340-8e35-a4b390c1d3e4_compressed_9786267866184.webp',
    description: '造神、抹黑、無中生有，刪掉演義濾鏡，忠臣賊子誰還分得清？評點英雄與紅顏，發掘演義之外的三國真相。',
    searchUrl: 'https://search.books.com.tw/search/query?key=9786267866184',
  },
  {
    id: 'book-k6010',
    title: '當世界為一桶油改變方向',
    author: '林修遠',
    isbn: '9786267866177',
    seriesCode: 'K6010',
    coverUrl:
      'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/aecb53e0-9538-4fef-a724-ccd9b74d31ad_compressed_9786267866177.webp',
    description: '黑金危機，能源時代的全球經濟動脈。從供需關係到地緣政治，拆解石油如何在多層結構中轉化為影響國家選擇的核心力量。',
    searchUrl: 'https://search.books.com.tw/search/query?key=9786267866177',
  },
  {
    id: 'book-k6008',
    title: '波希戰爭史——戰火中的帝國、城邦與同盟',
    author: '[英]喬治·威廉·考克斯 著，呂岩 譯',
    isbn: '9786267866153',
    seriesCode: 'K6008',
    coverUrl:
      'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/94d37bcc-dec0-42a1-9b1a-ba78034f65b9_compressed_9786267866153_3D_72dpi.webp',
    description: '從小亞細亞到愛琴海沿岸，一場由波斯帝國西進擴張，與希臘城邦世界發生的全面衝突。',
    searchUrl: 'https://search.books.com.tw/search/query?key=9786267866153',
  },
  {
    id: 'book-k6005',
    title: '不是她們毀了王朝——是歷史需要代罪羔羊',
    author: '山陽、金躍軍',
    isbn: '9786267866115',
    seriesCode: 'K6005',
    coverUrl:
      'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/344b453e-fe0c-4e0e-b293-1da0ab337574_compressed_9786267866115_3D_72dpi.webp',
    description: '從西施到楊貴妃，權力崩塌時的女性替罪史。當權力需要代價，紅顏往往成為最沉默的犧牲者。',
    searchUrl: 'https://search.books.com.tw/search/query?key=9786267866115',
  },
];
